import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { CommonSetting } from "../../components/setting/CommonSetting";
import { useStore } from "../../store/UserStore";
import React, { useCallback, useEffect, useState } from "react";
import { DatePickerDialog } from "../DatePickerDialog";
import { MainNavProps } from "../navigation/main/MainParamList";
import { updateUserIfo } from "../../net/service";
import { getUid } from "../../store/token";
import { RemarkType } from "./MineRemark";
import { postJson } from "../../net/http";
import { hideLoading, showLoading } from "../../components/Loading";
import { showToast } from "../../components/Toast";
import { uploadImages } from "../../utils/upload";
import {
  Str_Account,
  Str_Birthday,
  Str_ImgUploadFail,
  Str_Man,
  Str_MyQRCode,
  Str_Nick,
  Str_NotDisclose,
  Str_NotSet,
  Str_PersonalInfo,
  Str_Sex,
  Str_UpdateAvatar,
  Str_Woman,
} from "../../language/string_res";
import {
  PickerResult,
  openSinglePicker,
} from "../../utils/PicOrCameraManager";
import { LeftView } from "../Chat/CListItem";
import { Platform, Pressable, StyleSheet, Text, View } from "react-native";
import { black50, white } from "../../assets/style/colors";
import TakeIcon from "../../assets/svg/ic_take.svg";
import { getAvatarByUser } from "../../utils/utils";
import { UploadKey } from "../../utils/ReactBlobUtil";

export const PersonalDetails = ({
  navigation,
}: MainNavProps<"PersonalDetails">) => {
  const uid = getUid();
  const [pickerVisible, setPickerVisible] = useState(false);
  const { state, dispatch } = useStore();
  const [birthday, setBirthday] = useState("");
  const [avatar, setAvatar] = useState<string>();
  const [nick, setNick] = useState("");
  const [sex, setSex] = useState("");

  useEffect(() => {
    const user = state?.user;
    setBirthday(user?.birth ?? Str_NotSet);
    let s = Str_NotSet;
    if (user?.sex) {
      s =
        user.sex === "0"
          ? Str_Woman
          : user.sex === "1"
          ? Str_Man
          : Str_NotDisclose;
    }
    setSex(s);
    setNick(user?.nick ?? "");
    setAvatar(user?.avatar);
  }, [state?.user]);

  const uploadImage = (result: PickerResult) => {
    showLoading();
    uploadImages([result], UploadKey.Profile)
      .then((r) => {
        if (r.responses && r.responses.length > 0) {
          const data = r.responses[0];
          updateImage(data.url);
        } else {
          console.warn("[PersonalDetails] 上传失败：响应为空");
          hideLoading();
          showToast(Str_ImgUploadFail);
        }
      })
      .catch((error) => {
        console.error("[PersonalDetails] uploadImages 失败:", error);
        hideLoading();
      });
  };

  const updateImage = (url: string) => {
    updateUserIfo({ avatar: url })
      .then((data) => {
        if (data.code === 0) {
          if (state && state.user) {
            dispatch({
              type: "UPDATE_USER_INFO",
              payload: { ...state.user, avatar: url },
            });
          }
        }
      })
      .finally(() => {
        hideLoading();
      });
  };

  function handleBirthday(bir: string) {
    showLoading();
    const body = { birth: bir };
    postJson<any>(`/v1/sdk/user/profile/set`, { body })
      .then((res: any) => {
        if (res.code === 0) {
          if (state && state.user) {
            dispatch({
              type: "UPDATE_USER_INFO",
              payload: { ...state.user, birth: bir },
            });
          }
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  const openRemark = (type: RemarkType) => {
    const currentValue = type === "sex" ? sex : type === "remark" ? nick : "";
    navigation.navigate("MineRemark", {
      type: type,
      id: uid,
      currentValue: currentValue,
    });
  };

  return (
    <BaseScreen>
      <NavBar showBack={Platform.OS !== "web"} title={Str_PersonalInfo} />
      <DatePickerDialog
        defValue={birthday}
        visible={pickerVisible}
        onComplete={({ year, month, day }) => {
          handleBirthday(`${year}/${month}/${day}`);
        }}
        setVisible={setPickerVisible}
      />
      <View style={styles.contentContainer}>
        <Pressable
          style={styles.avatarContainer}
          onPress={() => {
            // Web 上直接打开文件选择器
            openSinglePicker("photo")
              .then((r) => {
                if (r) {
                  uploadImage(r);
                }
              })
              .catch((error) => {
                console.error("[PersonalDetails] 选择图片失败:", error);
              });
          }}
        >
          {state?.user
            ? <LeftView
              left={getAvatarByUser(state.user)}
              size={100}
              isRounded={true}
              isGroup={false}
              radius={100}
              style={{
                marginLeft: 0,
                marginRight: 0,
              }}
            />
            : null}
          <View
            style={{
              height: 100,
              width: 100,
              position: "absolute",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: black50,
              borderRadius: 50,
            }}
          >
            <TakeIcon width={30} height={30} />
            <Text
              style={{
                fontSize: 14,
                color: white,
                marginTop: 4,
                textAlign: "center",
                maxWidth: 80,
              }}
            >
              {Str_UpdateAvatar}
            </Text>
          </View>
        </Pressable>
        <CommonSetting
          style={{ marginTop: 12, borderRadius: 0 }}
          itemOption={[
            {
              text: Str_Account,
              rightType: "None",
              rightText: state?.user?.employee || "",
            },
            {
              text: Str_Nick,
              rightType: "Back",
              rightText: nick,
              onClick: () => {
                openRemark(RemarkType.REMARK);
              },
            },
            {
              text: Str_Sex,
              rightType: "Back",
              rightText: sex,
              onClick: () => {
                openRemark(RemarkType.SEX);
              },
            },
            {
              text: Str_Birthday,
              rightType: "Back",
              rightText: birthday,
              onClick: () => {
                setPickerVisible(true);
              },
            },
            {
              text: Str_MyQRCode,
              rightType: "Back",
              onClick: () => {
                navigation.navigate("QRCodeScreen", { user: state?.user });
              },
            },
          ]}
        />
      </View>
    </BaseScreen>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    width: "100%",
    maxWidth: 800,
    alignSelf: "center",
    paddingHorizontal: 20,
    marginTop: 40,
    backgroundColor: "white",
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    paddingTop: 24,
    paddingBottom: 8,
  },
  avatarContainer: {
    alignItems: "center",
    marginBottom: 20,
  },
});
